import { render, staticRenderFns } from "./TabelaDocumentosPadrao.vue?vue&type=template&id=c58c0712&"
import script from "./TabelaDocumentosPadrao.vue?vue&type=script&lang=js&"
export * from "./TabelaDocumentosPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports